import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/BillVSOPCVanReport';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const BillVSOPCVanReport = ({ t }) => (
  <Container>
   
       
    <Row>
      <HorizontalForm />
    </Row>

   
  </Container>
);

BillVSOPCVanReport.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(BillVSOPCVanReport);
